import React, { useMemo } from 'react';
import { Retailer } from '../../Types/Retailer';
import Icon from '../Icon';
import { translate } from '../../Services/translation';

interface RetailerStoreCardProps {
  retailer: Retailer;
}

const RetailerStoreCard = ({ retailer }: RetailerStoreCardProps) => {
  const directionsUrl = useMemo(() => {
    return `https://www.google.com/maps?saddr=My+Location&daddr=${retailer.position.lat},${retailer.position.lng}`;
  }, [retailer]);
  return (
    <div className="rounded border border-gray-200 bg-gray-100 px-4 pb-2 pt-3">
      <div className="text-lg font-medium">{retailer.name}</div>
      <div className="my-3 flex flex-col gap-2">
        <div className="flex gap-1">
          <Icon className="h-5 w-5" name="map-pin-light" />
          <span className="flex flex-1 text-md text-gray-700">
            {retailer.address1}, {retailer.zipCode} {retailer.city},{' '}
            {retailer.country}.
          </span>
        </div>
        {retailer.phoneNumber && (
          <div className="flex gap-1">
            <Icon className="h-5 w-5" name="phone-light" />
            <span className="flex flex-1 text-md text-gray-700 underline">
              <a href={`tel:${retailer.phoneNumber}`}>
                {retailer.phoneNumber}
              </a>
            </span>
          </div>
        )}
        {retailer.email && (
          <div className="flex gap-1">
            <Icon className="h-5 w-5" name="mail" />
            <span className="flex flex-1 text-md text-gray-700 underline">
              <a href={`mailto:${retailer.email}`}>{retailer.email}</a>
            </span>
          </div>
        )}
        {retailer.website && (
          <div className="flex gap-1">
            <Icon className="h-5 w-5" name="link-light" />
            <span className="flex flex-1 text-md text-gray-700 underline">
              <a href={retailer.website}>{retailer.website}</a>
            </span>
          </div>
        )}
      </div>
      {retailer.position.lat && retailer.position.lng && (
        <a
          className="-ml-2 mt-2 p-2 text-md underline"
          target="_blank"
          href={directionsUrl}
          rel="noreferrer"
        >
          {translate('retailers.show-directions')}
        </a>
      )}
    </div>
  );
};

export default RetailerStoreCard;
